import(/* webpackMode: "eager" */ "/vercel/path0/app/partenaires/page.tsx");
